import LegalContent from "./LegalContent";

export { LegalContent };
